var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepperArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.264 4.354a.5.5 0 000-.708L17.082.464a.5.5 0 10-.707.708L19.203 4l-2.828 2.828a.5.5 0 00.707.708l3.182-3.182zM.91 4.5h19v-1h-19v1z",
    fill: "#A0A0A0"
  })));
}
export default __webpack_public_path__ + "static/media/stepper-arrow.e24c07c6.svg";
export { SvgStepperArrow as ReactComponent };